/**
 * Window events that keep separately mounted widgets in step after sign-in:
 * the header avatar (and its birth-date prompt) and the booking flow each
 * have their own sign-in modal.
 */
export const AUTH_CHANGED = "rawej:auth-changed";
export const BIRTHDATE_SAVED = "rawej:birthdate-saved";

export const announce = (event: typeof AUTH_CHANGED | typeof BIRTHDATE_SAVED) => {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(event));
};
